import { lazy } from "react";
import { build } from "../../tools/ConfigBuilder";

export default build([
	{
		path: "/profile/load/dispatching",
		component: lazy(() => import("./LoadDashboardPage")),
	},
]);
